import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Section from "../../../../ui-library/section/section";
import Row from "../../../../ui-library/column-system/row";
import Column from "../../../../ui-library/column-system/column";
import QuestionLink from "../../../../ui-library/question-link/question-link";
import { getCOVIDIntentUrl } from "../../../../../utils/question-url";
import { EventCategory } from "../../../../../utils/analytics";
import { MaskCategoryIntentsQuery } from "../../../../../../graphql-types";
import Container from "../../../../ui-library/container/container";

const MaskCategoryLinks: React.FC = () => {
  const [isExpanded, setExpanded] = React.useState<boolean>(false);

  const data = useStaticQuery<MaskCategoryIntentsQuery>(
    graphql`
      query MaskCategoryIntents {
        askAboutQuery {
          intentsByCategory(alias: "what-do-they-say-about-masks") {
            alias
            displayName
          }
        }
      }
    `
  );

  const intents = data.askAboutQuery.intentsByCategory;

  if (!intents || intents.length === 0) {
    return null;
  }

  const intentsToRender = isExpanded ? intents : intents.slice(0, 8);

  return (
    <Container>
      <Section heading="Frequently asked questions about masks">
        <Row>
          {intentsToRender.map((i) => (
            <Column key={i.alias} spanLg={6} spanMd={6} spanSm={12}>
              <QuestionLink
                to={getCOVIDIntentUrl(i.alias)}
                eventCategory={EventCategory.MaskStopsTransmission}
              >
                {i.displayName}
              </QuestionLink>
            </Column>
          ))}
        </Row>
      </Section>
    </Container>
  );
};

export default MaskCategoryLinks;
